export default __webpack_public_path__ + "23f12573f5a7b25c06df32cfacb20a25.svg";